import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { RemoteImage } from '@gem/modules/remote-storage';

import { ChatBackgroundImageSize } from 'APP/constants/appearance';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';

import { useChatBackgroundImagePresenter } from './ChatBackgroundImage.presenter';
import styles from './ChatBackgroundImage.styles.m.css';

interface IChatBackgroundImageProps {
  background: TChatBackground;
  size: ChatBackgroundImageSize;
  className?: string;
}

export const ChatBackgroundImage: FC<IChatBackgroundImageProps> = observer(
  ({ background, className, size = ChatBackgroundImageSize.Original }) => {
    const presenter = useChatBackgroundImagePresenter({ background, size });

    return (
      <div className={classNames(styles.container, className)}>
        {presenter.imageUrl && (
          <RemoteImage
            alt={''}
            className={styles.image}
            src={presenter.imageUrl}
          />
        )}
      </div>
    );
  }
);
